export default "__VITE_ASSET__DqKGkijE__"